<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="backtop">
<g id="Union">
<path d="M2.99854 4.49854H20.9985V2.99854H2.99854V4.49854Z" fill="#473BF0"/>
<path d="M5.06534 15.3441L11.2299 9.29334L11.23 22.2658L12.7463 22.2657L12.7462 9.28533L19.0168 15.4009L20.0873 14.3502L12.3366 6.79108C12.142 6.60125 11.8313 6.60174 11.6373 6.7922L3.99149 14.2968L5.06534 15.3441Z" fill="#473BF0"/>
</g>
</g>
</svg>

</template>